import { OfferStatus } from '../../services'
import { Color } from '../../theme'

export const getColorByStatus = (status: OfferStatus): Color => {
  switch (status) {
    case OfferStatus.NEW:
      return 'yellow'
    case OfferStatus.DRAFT:
      return 'inactiveSecondary'
    case OfferStatus.ACCEPTED:
      return 'active'
    case OfferStatus.ACCEPTED_BACK_FROM_CART:
      return 'active'
    default:
      return 'error'
  }
}
